import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 92px;
`;

export const Text = styled.div`
  font-size: 16px;
  line-height: 28px;
  color: var(--ds-text, var(--ds-fb-text));
  padding-left: 0.5em;
`;
